export const GALLERY_EDITOR_GRID_DROP_CONSTS = {
  changePhotoPosition: 'Нажмите и перетащите блок вверх/вниз для изменения позиции фото в галерее',
  deletePhotoConfirmBtn: 'Да, удалить',
  deletePhotoConfirmationText: 'удалить фото из галереи?',
  from: 'из',
  photo: 'Фото'
}
